<div class="d-flex justify-content-center">
  <div class="pr-2">
    <button
      mat-icon-button
      type="button"
      (click)="fireEventExibir()"
      [disabled]="(loadingAutorizacao$ | async) || (loadingRejeicao$ | async)"
      title="Consultar">
      <i class="fas fa-search" aria-hidden="true"></i>
    </button>
  </div>
  <div class="pr-2">
    <mat-spinner class="m-2" *ngIf="(loadingAutorizacao$ | async)" diameter="24"></mat-spinner>
    <button
      *ngIf="!(loadingAutorizacao$ | async)"
      mat-icon-button type="button"
      title="Autorizar"
      [disabled]="(loadingRejeicao$ | async)"
      (click)="autorizar()">
      <i class="fa fa-check text-success" aria-hidden="true"></i>
    </button>
  </div>
  <div>
    <mat-spinner class="m-2" *ngIf="(loadingRejeicao$ | async)" diameter="24"></mat-spinner>
    <button
      *ngIf="!(loadingRejeicao$ | async)"
      mat-icon-button color="warn"
      type="button"
      title="Rejeitar"
      [disabled]="(loadingAutorizacao$ | async)"
      (click)="rejeitar()">
      <i class="fa fa-times text-danger" aria-hidden="true"></i>
    </button>
  </div>
</div>
